"use strict";
import { jsx } from "react/jsx-runtime";
import React from "react";
import Auth from "../util/auth";
import { Flash } from "../components/flash";
import WaitingSpinner from "../components/waiting_spinner";
function afterLogoutDestination() {
  const oktaConfig = JSON.parse(window.oktaConfig);
  const user = Auth.getCurrentUser();
  let destination = "/app/login";
  if (user && user["okta_enabled?"]) {
    destination = oktaConfig.logoutRedirectUri;
  }
  return destination;
}
function logoutAndRedirect() {
  return Auth.logout().then(() => {
    Flash.success("Logged out successfully!");
    window.location.href = afterLogoutDestination();
  });
}
var Logout = React.createClass({
  // LIFECYCLE
  getInitialState: function() {
    return {
      loading: true
    };
  },
  componentWillMount: function() {
    logoutAndRedirect();
  },
  componentWillReceiveProps: function() {
    logoutAndRedirect();
  },
  // RENDERING
  render: function() {
    return /* @__PURE__ */ jsx(WaitingSpinner, { "data-component": "Logout", when: this.state.loading, children: /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-6 small-centered columns", children: /* @__PURE__ */ jsx("div", { className: "panel callout radius", children: "Logging out\u2026" }) }) }) });
  }
});
export default Logout;
